import { Schema } from "effect";
import { TeamsCallVerbosity } from "./FeatureFlags.js";
const LobbyIntervieweeDetails = Schema.Struct({
    name: Schema.optional(Schema.String),
    email: Schema.optional(Schema.String),
    phoneNumber: Schema.optional(Schema.String),
    phoneCountry: Schema.optional(Schema.String),
    smsOptIn: Schema.optional(Schema.Boolean),
    smsOptOut: Schema.optional(Schema.Boolean),
    recordOptIn: Schema.optional(Schema.NullishOr(Schema.Boolean)),
    recordOptOut: Schema.optional(Schema.NullishOr(Schema.Boolean)),
});
export const LobbyDetails = Schema.Struct({
    interviewer: Schema.String,
    interviewee: Schema.String,
    startTimeDate: Schema.Date,
    endTimeDate: Schema.Date,
    teamsToken: Schema.String,
    meetingJoinUrl: Schema.String,
    recordingOptOut: Schema.NullishOr(Schema.Boolean),
    meetNow: Schema.optional(Schema.Boolean),
    disableRecordingOptions: Schema.optional(Schema.Boolean),
    intervieweeDetails: Schema.optional(LobbyIntervieweeDetails),
    acsLogLevel: Schema.optional(TeamsCallVerbosity),
    uploadAcsLogs: Schema.optional(Schema.Boolean),
});
